import {
  saveOnceToSessionStorage,
  clearFromSessionStorage,
} from '../lib/helpers';

import {
  FETCH_REPORTS_REQUEST,
  FETCH_REPORTS_FAILURE,
  FETCH_REPORTS_SUCCESS,
} from '../actions/reports';

import {
  SESSION_STORAGE_CANDIDATE_IDS_KEY,
  SESSION_STORAGE_CONTACT_EMAIL_KEY,
  SESSION_STORAGE_CONTACT_NAME_KEY,
} from '../constants';

// ECDEX-3840 (slice 2): the deletion request moved to usePiiDeletion. What is
// left is the contact details the report fetch hands over (the thunks in
// actions/reports.js still dispatch them); they leave with the portal slice.
export const initialState = {
  candidate_ids: undefined,
  contact_email: undefined,
  contact_name: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REPORTS_REQUEST:
      saveOnceToSessionStorage(
        SESSION_STORAGE_CONTACT_EMAIL_KEY,
        action.search.email,
      );

      return {
        ...state,
        contact_email: action.search.email,
      };
    case FETCH_REPORTS_FAILURE:
      clearFromSessionStorage(SESSION_STORAGE_CONTACT_EMAIL_KEY);

      return {
        ...state,
        contact_email: undefined,
      };
    case FETCH_REPORTS_SUCCESS:
      // If we have a token saved instead of a fresh request, monolith returns []
      // This preserves the IDs on the initial success where we don't use a token
      saveOnceToSessionStorage(
        SESSION_STORAGE_CANDIDATE_IDS_KEY,
        action.privacyCandidateIds,
      );
      saveOnceToSessionStorage(
        SESSION_STORAGE_CONTACT_NAME_KEY,
        action.privacyCandidateName,
      );

      return {
        ...state,
        candidate_ids: action.privacyCandidateIds,
        contact_name: action.privacyCandidateName,
      };
    default:
      return state;
  }
};
